// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7C_S6","col":"styles_col__1x8Jc"};